import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Text, Btn } from "./ui";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-korio-bg px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <img src="/brand/name.webp" alt="KORIO" className="mx-auto h-10" />
          <p className="mt-4 text-sm uppercase tracking-[0.25em] text-white/40">Admin back-office</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4 rounded-2xl border border-white/10 bg-korio-surface p-8">
          <Text label="Email" value={email} onChange={setEmail} placeholder="admin@korio.eu" testid="admin-email" />
          <div>
            <span className="mb-1.5 block text-xs font-medium uppercase tracking-wider text-white/50">Password</span>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-white outline-none focus:border-volt focus:ring-1 focus:ring-volt/40" />
          </div>
          <Btn type="submit" disabled={busy} testid="admin-login-submit">{busy ? "Signing in..." : "Sign in"}</Btn>
        </form>
      </div>
    </div>
  );
}
